/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { CommonModule, DatePipe } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { ErrorHandler, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'
import { ApiServiceBase, ModelMiscModule } from '@sightline/models-misc'
import { environment } from '../environments/environment'
import { PhoneMaskDirective } from './directives/phone-mask.directive'
import { FooterComponent } from './footer/footer.component'
import { HeaderComponent } from './header/header.component'
import { MyProfileComponent } from './header/my-profile/my-profile.component'
import { IdleMessageComponent } from './idle-message/idle-message.component'
import { NavMenuComponent } from './nav-menu/nav-menu.component'
import { ApiService } from './services/api/api.service'
import { CacheService } from './services/business/cache.service'
import { ClaimsService } from './services/business/claims.service'
import { PlatformService } from './services/business/platform.service'
import { UtilsService } from './services/business/utils.service'
import { NotificationService } from './services/ui/notification.service'
import { SlpDatePickerComponent } from './slp-date-picker/slp-date-picker.component'
import { SlpSearchComponent } from './slp-search/slp-search.component'
import { ClickNoPropagateDirective } from './directives/click-no-propagate.directive'
import { ValidationMessagesComponent } from './validators/validation-messages/validation-messages.component'
import { GlobalErrorHandler } from './error-handling/global-error-handler'
import { LoadingPlaceholderComponent } from './loading-placeholder/loading-placeholder.component'
import { PhonePipe } from './pipes/phone.pipe'
import { MoneyPipe } from './pipes/money.pipe'
import { NumberDirective } from './directives/number.directive'
import { MaterialModule } from '../app/material/material.module'
import { DateDirective } from './directives/date.directive'
import { TitleService } from './services/ui/title.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics'
import { PlatformClassDirective } from './directives/slp-ionic-platform.directive'
import { LanguageTranslationService } from './services/ui/languageTranslation.service'
import { TrimDirective } from './directives/trim.directive'
import { HtmlContentModalComponent } from './html-content-modal/html-content-modal.component'
import { MaskPipe } from './directives/mask.pipe'
import { IPv4InputDirective } from './directives/ipv4.directive'
import { IPv6InputDirective } from './directives/ipv6.directive'
import { AuthInterceptor } from '../../src/security/models/services/auth'
import { API_CONFIG } from '../../src/security/models/services/users/userApi.service'
import {
  IonTabButton, IonTabBar, IonHeader, IonToolbar, IonLabel, IonIcon, IonContent, IonList,
  IonRadioGroup, IonListHeader, IonItem, IonRadio, IonText, IonInput, IonFooter,
  IonButton, IonRow, IonCol, IonGrid, IonPopover, IonSpinner, IonModal, IonSelectOption,
  IonItemDivider, IonBreadcrumb, IonBreadcrumbs, IonCard, IonCardHeader, IonCardContent,
  IonCardSubtitle, IonCardTitle, IonSelect, IonReorder, IonReorderGroup, IonCheckbox,
  IonAccordionGroup, IonAccordion, IonSegment, IonSegmentButton, IonToggle, IonMenu,
  IonTextarea, IonMenuButton, IonAvatar, IonNote, IonTitle, IonMenuToggle,
  IonButtons
} from '@ionic/angular/standalone'

@NgModule({
  imports: [
    CommonModule,
    NgxGoogleAnalyticsModule,
    MaterialModule,
    RouterModule,
    ModelMiscModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule,
    IonHeader,
    IonToolbar,
    IonLabel,
    IonIcon,
    IonContent,
    IonList,
    IonRadioGroup,
    IonListHeader,
    IonItem,
    IonRadio,
    IonText,
    IonTextarea,
    IonInput,
    IonFooter,
    IonButton,
    IonRow,
    IonCol,
    IonGrid,
    IonPopover,
    IonTabBar,
    IonSpinner,
    IonModal,
    IonSelect,
    IonSelectOption,
    IonItemDivider,
    IonBreadcrumb,
    IonBreadcrumbs,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonCardSubtitle,
    IonCardTitle,
    IonReorderGroup,
    IonReorder,
    IonCheckbox,
    IonAccordionGroup,
    IonAccordion,
    IonSegment,
    IonSegmentButton,
    IonToggle,
    IonMenuButton,
    IonAvatar,
    IonNote,
    IonTitle,
    IonMenuToggle,
    IonMenu,
    IonTabButton,
    IonButtons
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    NavMenuComponent,
    IdleMessageComponent,
    MyProfileComponent,
    PhoneMaskDirective,
    SlpDatePickerComponent,
    SlpSearchComponent,
    ClickNoPropagateDirective,
    ValidationMessagesComponent,
    LoadingPlaceholderComponent,
    PhonePipe,
    MoneyPipe,
    MaskPipe,
    NumberDirective,
    DateDirective,
    TrimDirective,
    PlatformClassDirective,
    HtmlContentModalComponent,
    IPv4InputDirective,
    IPv6InputDirective
  ],
  exports: [
    FooterComponent,
    TranslateModule,
    HeaderComponent,
    NavMenuComponent,
    IdleMessageComponent,
    MyProfileComponent,
    PhoneMaskDirective,
    SlpDatePickerComponent,
    SlpSearchComponent,
    ClickNoPropagateDirective,
    NumberDirective,
    DateDirective,
    ValidationMessagesComponent,
    LoadingPlaceholderComponent,
    PhonePipe,
    MoneyPipe,
    MaskPipe,
    TrimDirective,
    PlatformClassDirective,
    HtmlContentModalComponent,
    IPv4InputDirective,
    IonHeader,
    IonToolbar,
    IonLabel,
    IonIcon,
    IonContent,
    IonList,
    IonRadioGroup,
    IonListHeader,
    IonItem,
    IonRadio,
    IonText,
    IonTextarea,
    IonInput,
    IonFooter,
    IonButton,
    IonRow,
    IonCol,
    IonGrid,
    IonPopover,
    IonTabBar,
    IonSpinner,
    IonModal,
    IonSelect,
    IonSelectOption,
    IonItemDivider,
    IonBreadcrumb,
    IonBreadcrumbs,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonCardSubtitle,
    IonCardTitle,
    IonReorderGroup,
    IonReorder,
    IonCheckbox,
    IonAccordionGroup,
    IonAccordion,
    IonSegment,
    IonSegmentButton,
    IonToggle,
    IonMenuButton,
    IonAvatar,
    IonNote,
    IonTitle,
    IonMenuToggle,
    IonMenu,
    IonTabButton,
    IonButtons
  ],
  providers: [
    ApiServiceBase,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: ApiService, deps: [ApiServiceBase, API_CONFIG] },
    {
      provide: API_CONFIG,
      useValue: {
        url: environment.apiUrl,
        version: environment.apiVersion,
      },
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    DatePipe,
    PhonePipe,
    MoneyPipe,
    MaskPipe,
    PlatformService,
    UtilsService,
    CacheService,
    NotificationService,
    ClaimsService,
    TitleService,
    LanguageTranslationService
  ],
})
export class CommonsModule { }
